import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAgreementDetails } from "../../redux/homepage/saga";
import { useParams } from "react-router-dom";
import { AgreementDto } from "../../redux/homepage/type";
import { Loader } from "../../components";
import { Helmet } from "react-helmet";
import { getLocalization } from "../../redux/localization";

const AgreementPage = () => {
  const { id, lang }: any = useParams();
  const t = useSelector(getLocalization);
  const [loader, setLaoder] = useState(false);
  const [contract, setContract] = useState<AgreementDto>();
  const dispatch = useDispatch();

  useEffect(() => {
    setLaoder(true);
    dispatch(
      getAgreementDetails({
        payload: {
          onSuccess: (message, payload) => {
            setLaoder(false);
            return setContract(payload);
          },
          onError: () => {
            setLaoder(false);
          },
        },
        id: id,
      })
    );
  }, [id, dispatch, lang]);
  return (
    <React.Fragment>
      <Helmet>
        <title>
          {contract ? contract.Title : "" + t.getString(" | Rentificial")}        

        </title>
        <meta name="robots" content="noindex, nofollow"></meta>
        <link  rel="canonical"  href={`https://www.rentificial.com/agreements/${contract ? contract.Id : ""}`}/>
      </Helmet>
      <Container>
        <div className="page-content ">
          <Row>
            <Col>
              {loader && <Loader />}
              {contract ? (
                <>
                  <h1 dangerouslySetInnerHTML={{ __html: contract.Title }} />
                  <p
                    dangerouslySetInnerHTML={{ __html: contract.Description }}
                  />
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};
export default AgreementPage;
